/**
 *
 * Styles for EstimatedDeliveryInfo
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";

export const DeliveryTimeText = styled.span`
  margin-top: calc(var(--dui-size-space-7x) / 2);
  font-size: 2rem;
  font-weight: 200;
  font-stretch: condensed;
  font-style: normal;

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    padding-left: var(--dui-size-space-5x);
    margin-left: var(--dui-size-space-5x);
    border-left: var(--dui-size-width-border-sm) solid var(--dui-color-gray-300);
    line-height: 24px;
    &.text--giga.text--giga {
      line-height: 1;
    }
  }
`;

export const OfferFeaturesWrapper = styled.div`
  margin-top: var(--dui-size-space-5x);

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    padding-left: var(--dui-size-space-5x);
    margin-left: var(--dui-size-space-5x);
    border-left: var(--dui-size-width-border-sm) solid var(--dui-color-gray-300);
  }
`;

export const EstimatedDeliveryText = styled(DhlText)`
  & > *:is(p, span) {
    color: var(--dui-color-black-500);
    margin: 0;
    margin-bottom: var(--dui-size-space-1x);
  }
`;

export const DeliveryDateHeadline = styled(Headline)`
  margin: 0;
  white-space: normal;

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 33.5rem;
  }
`;

export const DateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: var(--gaq-size-space-5px);
  margin-bottom: var(--gaq-size-space-15px);

  @media screen and (min-width: ${breakpoints.desktop}) {
    line-height: 24px;
    flex-direction: row;
    display: inline-flex;
    margin-bottom: var(--dui-size-space-4x);
    align-items: center;
  }
`;
